export default __webpack_public_path__ + "static/media/hong-kong.18a25dcc.svg";